module.exports = __webpack_public_path__ + "static/media/funraiser.1877c540.png";